'use strict';

var _classCallCheck = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/createClass");
var ICAL = require('ical.js');

// Copied from https://dxr.mozilla.org/comm-central/source/calendar/timezones/zones.json
// And compiled using node compile-zones.js
// See also https://github.com/mozilla-comm/ical.js/issues/195
var timezones = require('./zones-compiled.json');
var IcalExpander = /*#__PURE__*/function () {
  function IcalExpander(opts) {
    _classCallCheck(this, IcalExpander);
    this.maxIterations = opts.maxIterations != null ? opts.maxIterations : 1000;
    this.skipInvalidDates = opts.skipInvalidDates != null ? opts.skipInvalidDates : false;
    this.jCalData = ICAL.parse(opts.ics);
    this.component = new ICAL.Component(this.jCalData);
    this.events = this.component.getAllSubcomponents('vevent').map(function (vevent) {
      return new ICAL.Event(vevent);
    });
    if (this.skipInvalidDates) {
      this.events = this.events.filter(function (evt) {
        try {
          evt.startDate.toJSDate();
          evt.endDate.toJSDate();
          return true;
        } catch (err) {
          // skipping events with invalid time
          return false;
        }
      });
    }
  }
  return _createClass(IcalExpander, [{
    key: "between",
    value: function between(after, before) {
      var _this = this;
      function isEventWithinRange(startTime, endTime) {
        return (!after || endTime >= after.getTime()) && (!before || startTime <= before.getTime());
      }
      function getTimes(eventOrOccurrence) {
        var startTime = eventOrOccurrence.startDate.toJSDate().getTime();
        var endTime = eventOrOccurrence.endDate.toJSDate().getTime();

        // If it is an all day event, the end date is set to 00:00 of the next day
        // So we need to make it be 23:59:59 to compare correctly with the given range
        if (eventOrOccurrence.endDate.isDate && endTime > startTime) {
          endTime -= 1;
        }
        return {
          startTime: startTime,
          endTime: endTime
        };
      }
      var exceptions = [];
      this.events.forEach(function (event) {
        if (event.isRecurrenceException()) exceptions.push(event);
      });
      var ret = {
        events: [],
        occurrences: []
      };
      this.events.filter(function (e) {
        return !e.isRecurrenceException();
      }).forEach(function (event) {
        var exdates = [];
        event.component.getAllProperties('exdate').forEach(function (exdateProp) {
          var exdate = exdateProp.getFirstValue();
          exdates.push(exdate.toJSDate().getTime());
        });

        // Recurring event is handled differently
        if (event.isRecurring()) {
          var iterator = event.iterator();
          var next;
          var i = 0;
          var _loop = function _loop() {
            i += 1;
            next = iterator.next();
            if (next) {
              var occurrence = event.getOccurrenceDetails(next);
              var _getTimes = getTimes(occurrence),
                _startTime = _getTimes.startTime,
                _endTime = _getTimes.endTime;
              var isOccurrenceExcluded = exdates.indexOf(_startTime) !== -1;

              // TODO check that within same day?
              var exception = exceptions.find(function (ex) {
                return ex.uid === event.uid && ex.recurrenceId.toJSDate().getTime() === occurrence.startDate.toJSDate().getTime();
              });

              // We have passed the max date, stop
              if (before && _startTime > before.getTime()) return 1; // break

              // Check that we are within our range
              if (isEventWithinRange(_startTime, _endTime)) {
                if (exception) {
                  ret.events.push(exception);
                } else if (!isOccurrenceExcluded) {
                  ret.occurrences.push(occurrence);
                }
              }
            }
          };
          do {
            if (_loop()) break;
          } while (next && (!_this.maxIterations || i < _this.maxIterations));
          return;
        }

        // Non-recurring event:
        var _getTimes2 = getTimes(event),
          startTime = _getTimes2.startTime,
          endTime = _getTimes2.endTime;
        if (isEventWithinRange(startTime, endTime)) ret.events.push(event);
      });
      return ret;
    }
  }, {
    key: "before",
    value: function before(_before) {
      return this.between(undefined, _before);
    }
  }, {
    key: "after",
    value: function after(_after) {
      return this.between(_after);
    }
  }, {
    key: "all",
    value: function all() {
      return this.between();
    }
  }]);
}();
function registerTimezones() {
  Object.keys(timezones).forEach(function (key) {
    var icsData = timezones[key];
    var icsTimezone = "BEGIN:VTIMEZONE\r\nTZID:".concat(key, "\r\n").concat(icsData, "\r\nEND:VTIMEZONE");
    var parsed = ICAL.parse("BEGIN:VCALENDAR\nPRODID:-//tzurl.org//NONSGML Olson 2012h//EN\nVERSION:2.0\n".concat(icsTimezone, "\nEND:VCALENDAR"));
    var comp = new ICAL.Component(parsed);
    var vtimezone = comp.getFirstSubcomponent('vtimezone');
    ICAL.TimezoneService.register(key, new ICAL.Timezone(vtimezone));
  });
}
registerTimezones();
module.exports = IcalExpander;